import { XMarkIcon } from '@heroicons/react/20/solid'
import { useRightSidebar } from '@/Layouts/RightSidebarContext'

export function RightSidebarPanel() {
    const { isOpen, setIsOpen, content } = useRightSidebar()

    return (
        <div
            className={`fixed top-0 right-0 z-20 h-screen w-[420px] transition-transform duration-300 ${
                isOpen ? 'translate-x-0' : 'translate-x-full'
            }`}
        >
            <div className="flex h-full flex-col border-l border-gray-200 bg-white shadow-lg">
                <div className="flex shrink-0 items-center justify-end border-b border-gray-200 px-4 py-3">
                    <button
                        type="button"
                        onClick={() => setIsOpen(false)}
                        className="rounded-md p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
                        aria-label="Assistent schließen"
                    >
                        <XMarkIcon className="h-5 w-5" />
                    </button>
                </div>

                <div className="min-h-0 flex-1 overflow-hidden">{content}</div>
            </div>
        </div>
    )
}
